export function scrollToInput(fieldName: string) {
  const element =
    document.querySelector(`[name=${fieldName}]`) ??
    document.querySelector(`[data-name=${fieldName}]`);

  element?.scrollIntoView({ block: 'center' });
}
